// VideoUploadProgressCard.jsx
import React, { useEffect, useState } from 'react';
import './VideoUploadProgressCard.scss';

const VideoUploadProgressCard = ({ videoFile, posterFile, progress }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (videoFile instanceof Blob) {
      const url = URL.createObjectURL(videoFile);
      setPreview(url);

      // Cleanup the URL object when component unmounts or file changes
      return () => URL.revokeObjectURL(url);
    } else {
      setPreview(null); // or leave as-is if not needed
    }
  }, [videoFile]);

  return (
    <div className="video-upload-progress-card">
      <div className="video-thumbnail">
        {videoFile ? (
          <video
            src={preview}
            muted
            disablePictureInPicture
            controlsList="nodownload noplaybackrate"
            width="100%"
          />
        ) : (
          <div className="video-placeholder">No Preview</div>
        )}
      </div>
      {videoFile && <div className="video-info">
        <p>Name: <strong>{videoFile.name}</strong></p>
        <p>File Size: <strong>{(videoFile.size / 1024 / 1024).toFixed(2)} MB</strong></p>
        <p>Type: <strong>{videoFile.type}</strong></p>
      </div>}
    </div>
  );
};

export default VideoUploadProgressCard;
